export default __webpack_public_path__ + "static/media/iq-img2.da16bc24.png";